<template>
  <div class="title-stranka-wrapper">
    <input
      class="form-input troskovnik-element-title"
      v-model="title"
    />
    <div class="stranka-protustranka-wrapper">
        <div v-for="(str, key) in field_osobe" :key="key" class="stranka-protustranka-inputs">
            <input
                id=""
                type="text"
                class="together-input stranka-input"
                v-model="str.name"
                placeholder="Unesite naziv osobe/institucije"
            />
            <textarea
                rows="3"
                class="together-input details-input"
                v-model="str.details"
                placeholder="Unesite detalje osobe/institucije"
            />
            <div class="add-remove-buttons-wrapper">
                <div class="add-napomena add-button add-checkitem" @click="addNewFields(str)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <g>
                            <g>
                                <path fill="#0acab1"
                                    d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="add-napomena add-button remove-item" @click="deleteStavka(str)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <g><g><path fill="#70707E" d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" /></g></g>
                    </svg>
                </div>
            </div>
        </div>
        <div v-if="field_osobe.length == 0" class="stranka-protustranka-inputs">
            <div class="add-remove-buttons-wrapper">
                <div class="add-napomena add-button add-checkitem" @click="addNewFields(0)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <g>
                            <g>
                                <path fill="#0acab1"
                                    d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
    props:['field_naslov', 'field_osobe'],
    methods: {
        addNewFields(str){
            this.field_osobe.splice(this.field_osobe.indexOf(str)+1, 0, {
              'name':'',
              'details':'',
            });
        },
        deleteStavka(str){
            let updated_stavke = this.field_osobe.filter((i)=>i != str);
            this.$emit('update:field_osobe', updated_stavke);
        }
    },
    computed: {
        title: {
            get () { return this.field_naslov },
            set (value) { this.$emit('update:field_naslov', value) },
        },
    },
}
</script>